import moment from "moment/moment";

export const formatToLocaleTime = (time: string) => {
  const now = new Date(time);
  const offsetMinutes = now.getTimezoneOffset();
  const isoStringWithOffset = new Date(
      now.getTime() - offsetMinutes * 60000
  ).toString();
  return moment(isoStringWithOffset).format("YYYY-MM-DD hh:mm:ss");
}